<template>
  <v-card>
    <v-card-text>
      <form-group class="ma-0 pa-0 mt-3">
        <notification-status-content
          v-model="status"
        />
        <v-row justify="start">
          <v-col cols="9">
            <input-text
              id="input:title"
              v-model="payload.title"
              label="Título das notificações"
              :rules="[requiredRule, maxLength(20)]"
              :loading="loading"
              counter="20"
              outlined
              required
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-textarea
              id="input:description"
              v-model="payload.description"
              label="Descrição das notificações"
              :rules="[requiredRule, maxLength(160)]"
              :loading="loading"
              rows="5"
              counter="160"
              outlined
            />
          </v-col>
        </v-row>
      </form-group>
    </v-card-text>
    <slot />
  </v-card>
</template>

<script>
import RulesMixin from '@/app/arch/mixins/RulesMixin';
import FormGroup from '@/app/arch/components/crud/components/FormGroup.vue';
import NotificationStatusContent from 'Modules/contacard/communication/notifications/components/contents/NotificationStatusContent.vue';

export default {
  name: 'NotificationConfigContent',
  components: { FormGroup, NotificationStatusContent },
  mixins: [RulesMixin],
  computed: {
    payload() {
      return this.notification.payload;
    },
    loading() {
      return this.notification.loading;
    },
    status: {
      get() {
        return this.notification.status;
      },
      set(value) {
        this.handleStatus(value);
      },
    },
  },
  inject: {
    notification: {
      default() {
        return {
          payload: {
            title: '',
            description: '',
            scheduledDate: '',
          },
          loading: '',
          status: '',
        };
      },
    },
    handleStatus: {
      default() {
        return (v) => v;
      },
    },
  },
};
</script>
